import {
  Directive,
  OnChanges,
  AfterViewInit,
  EventEmitter,
  OnInit,
  Output,
  Input,
  OnDestroy,
  ElementRef,
  SimpleChange
} from "@angular/core";
import { dragula, DragulaService } from "ng2-dragula";
import * as _ from "lodash";

@Directive({ selector: "ngx-datatable[dragulaName]" })
export class DragulaExtendedDirective
  implements OnChanges, OnInit, AfterViewInit, OnDestroy {
  @Input() dragulaName: string;
  @Input() dragulaModel: any;
  @Input() classSelector: string = "null";
  @Output() directiveDrop: EventEmitter<any> = new EventEmitter<any>();
  @Output() directiveDrag: EventEmitter<any> = new EventEmitter<any>();

  protected container: any;
  private drake: any;
  private options: any;
  private el: ElementRef;
  private dragulaService: DragulaService;
  subscriptionDrag: any = null;
  subscriptionDrop: any = null;

  public constructor(el: ElementRef, dragulaService: DragulaService) {
    this.el = el;
    this.dragulaService = dragulaService;
  }
  ngOnInit() {}

  ngAfterViewInit() {
    const observer = new MutationObserver(mutations => {
      if (mutations.length) {
        this.init();
      }
    });

    observer.observe(this.el.nativeElement, {
      attributes: true,
      childList: true,
      characterData: true
    });
  }

  initialized = false;
  async init() {
    //if (this.initialized) return;
    if (!this.el) return;
    const rowParent = this.el.nativeElement.querySelector("datatable-scroller");
    if (!rowParent) return;
    this.initialized = true;

    //not mandatory
    rowParent.style.cursor = "grab !important";
    rowParent.style.userSelect = "none !important";

    // Check if this Dragula already exists
    if (!this.dragulaService.find(this.dragulaName)) {
      // Must assign the new rowParent as the container you want to pass to Dragula
      this.container = rowParent;
      this.initializeDragula();
    }
  }

  ngOnDestroy() {
    // Clear this Dragula always
    // comment out if you want to keep it
    if (this.dragulaService.find(this.dragulaName)) {
      this.dragulaService.destroy(this.dragulaName);
    }

    // Clear DRAG and DROP subscription to prevent duplicates
    if (this.subscriptionDrag) {
      this.subscriptionDrag.unsubscribe();
      this.subscriptionDrag = null;
    }
    if (this.subscriptionDrop) {
      this.subscriptionDrop.unsubscribe();
      this.subscriptionDrop = null;
    }
  }

  protected initializeDragula() {
    // Create new Dragula container
    let bag = this.dragulaService.find(this.dragulaName);
    if (bag) {
      this.drake = bag.drake;
      this.checkModel();
      this.drake.containers.push(this.container);
    } else {
      // Check if classSelector was specified
      // *true:
      //    - the classSelector string will be used to match the class of the element clicked
      //    - the element with the matching class name will be used to drag the row
      // *false:
      //    - no class selector will be used
      //    - the whole row will default back to being draggable
      if (this.classSelector != "null") {
        let classSelector = this.classSelector;
        let options = {
          moves: function(el, container, handle) {
            return handle.className === classSelector;
          }
        };
        this.drake = dragula([this.container], options);
      } else {
        this.drake = dragula([this.container]);
      }
      this.checkModel();
      this.dragulaService.add(this.dragulaName, this.drake);
    }

    // Set DRAG and DROP subscriptions and callbacks
    this.subscriptionDrag = this.dragulaService.drag.subscribe(value => {
      if (value[0] != this.dragulaName) return;
      this.on_drag(value);
    });
    this.subscriptionDrop = this.dragulaService.drop.subscribe(value => {
      if (value[0] != this.dragulaName) return;
      this.on_drop(value);
    });
  }

  private checkModel() {
    if (this.dragulaModel) {
      if (this.drake.models) {
        this.drake.models.push(this.dragulaModel);
      } else {
        this.drake.models = [this.dragulaModel];
      }
    }
  }

  before_drag = [];
  on_drag(value) {
    this.before_drag = _.cloneDeep(this.dragulaModel);
  }

  on_drop(value) {
    const range: any = this.find_index_range(
      this.before_drag,
      this.dragulaModel,
      "id"
    );
    range.newArray = _.cloneDeep(this.dragulaModel);

    // Added emitter on any DROP action
    this.directiveDrop.emit(range);
    this.before_drag = [];
  }

  find_index_range(
    previousModel: any[],
    currentModel: any[],
    uniq_key: string
  ): { from_index: number; to_index: number; elementsorder: any[] } {
    let from_index = undefined;
    let to_index = undefined;
    const elementsorder = [];

    loop_start: for (const { item, index } of previousModel.map(
      (item, index) => ({ item, index })
    )) {
      if (item[uniq_key] == currentModel[index][uniq_key]) {
        if (from_index == undefined) continue;
        else break loop_start;
      }
      if (from_index == undefined) from_index = index;
      to_index = index;
      elementsorder.push({
        uniq: currentModel[index][uniq_key],
        newIndex: index
      });
    }

    return { from_index, to_index, elementsorder };
  }

  public ngOnChanges(changes: { dragulaModel?: SimpleChange }): void {
    // Must update model on any changes
    // Otherwise it will fall out of sync with the 'dragulaModel'
    if (changes && changes.dragulaModel) {
      if (this.drake) {
        if (this.drake.models) {
          let modelIndex = this.drake.models.indexOf(
            changes.dragulaModel.previousValue
          );
          this.drake.models.splice(
            modelIndex,
            1,
            changes.dragulaModel.currentValue
          );
        } else {
          this.drake.models = [changes.dragulaModel.currentValue];
        }
      }
    }
  }
}
